import React from 'react';

class MultiChoiceOption extends React.Component {
	render() {
		const imgSource = this.props.checked ? 
			require('../assets/checkbox_checked.png') : 
			require('../assets/checkbox_unchecked.png');
		return (
			<div>
				<div className="pointer" onClick={this.props.onClick} style={{
					display: 'flex',
					flexDirection: 'row',
					minHeight: 48,
					alignItems: 'center'
				}}>
					<div style={{
						paddingLeft: 16,
						paddingRight: 16
					}}>
						<img src={imgSource} style={{
							width: 24,
							height: 24
						}} />
					</div>
					<div style={{
						paddingRight: 16
					}}>
						{this.props.option.option_text}
					</div>
				</div>
			</div>
		);
	}
}

export default MultiChoiceOption;


// WEBPACK FOOTER //
// ./src/components/multichoiceoption.jsx